<template>
    <div class="chart-bar white-bkg bl-1 br-1 bb-1 py-3 px-5 flex-column jc-center br br-top-0">
        <component v-if="status === 'success'" :data="chartData" :is="chart"></component>
        <div v-else class="prelative"><preloader :display="true"/></div>
    </div>
</template>

<script>

    import Preloader from "vcomponents/utilities/Preloader.vue";
    import VerticalBarChart from 'vcomponents/chart/VerticalBarChart.vue';
    import HorizontalBarChart from 'vcomponents/chart/HorizontalBarChart.vue';

    import { createNamespacedHelpers } from 'vuex';

    const report = createNamespacedHelpers('report');

    /**
     * List of graphs available for viewing reports
     * When a new type of archive result is avaible, add the corresponding adapter in the list
     */
    const charts = {
        "staff": HorizontalBarChart,
        "all"  : VerticalBarChart,
        "label": HorizontalBarChart
    };

    export default {
        computed: {
            ...report.mapGetters([
                'type',
                'chartData',
                'status'
            ]),
            chart() {
                return charts[this.type];
            }
        },
        components: {
            Preloader,
            VerticalBarChart,
            HorizontalBarChart
        },
    }
</script>

<style lang="scss" scoped>
    .chart-bar {
        min-height: 450px;
    }
</style>